import { z } from 'zod';

import {
    IValidationResultsCollector,
    ValidationClassResult,
    ValidationResult,
} from '../../ScriptingEngineEnvironment/Touchpoint/DocumentValidation';

// TODO: Add more fields to the schema to replace ValidationResult
const validationResultSchema = z
    .object({
        detailArguments: z.any().array().default([]),
        titleArguments: z.any().array().default([]),
    })
    .passthrough();

export class ValidationResultsCollector implements IValidationResultsCollector {
    validationResults: ValidationClassResult[] = [];

    addError(result: ValidationResult): void {
        const validationResult = validationResultSchema.parse(result);

        this.validationResults.push({
            validationClass: 'Error',
            // TODO: Remove the type assertion once ValidationResult has been replaced with the schema
            result: validationResult as unknown as ValidationResult,
        });
    }

    addWarning(result: ValidationResult): void {
        const validationResult = validationResultSchema.parse(result);

        this.validationResults.push({
            validationClass: 'Warning',
            // TODO: Remove the type assertion once ValidationResult has been replaced with the schema
            result: validationResult as unknown as ValidationResult,
        });
    }

    public getResults(): ValidationClassResult[] {
        return this.validationResults;
    }
}
